import * as Actions from "../constants/FoodConstants";

const InitialState = {
	menuData: {},
	brandDetails: {},
	dishDetails: {},
	recipesMap: {},
	ingredientDetails: {},
	dishesDataDynamic: {},
	nextAvailableSlots: {},
	allergies: {},
    pricingMap:{},
};

export const Food = (state = InitialState, action: any) => {
	switch (action.type) {
		case Actions.STORE_STATIC_DATA:
			var { allergens, ...rest } = action.data;
			return {
				...state,
				allergies: allergens,
				...rest,
			};

		case Actions.STORE_DYNAMIC_DATA:
			return {
				...state,
				...action.data,
			};

		case Actions.STORE_FOOD_DATA:
			var { allergens, ...rest } = action.data;
			return {
				...state,
				allergies: allergens,
				...rest,
			};

		case Actions.CLEAR_FOOD_DATA:
			return {
				...InitialState,
			};

		default:
			return {
				...state,
			};
	}
};

export default Food;
